import { useQuery } from "@tanstack/react-query";
import { getGoogleAdsStatus } from "../../api/bGoogleAdsApi";

export const useGetGoogleAdsStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["google-ads-status", organisationId],
    queryFn: () => getGoogleAdsStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
